import { useEffect } from 'react';

/** Título base del sitio; se mantiene como sufijo en todas las vistas. */
const BASE = 'MuniBus — Paine';

/**
 * Fija `document.title` mientras la vista está montada.
 *
 * Las vistas comparten un único `index.html`, por lo que sin esto todas reportan el mismo
 * título y los informes por título de Analytics las agrupan en una sola fila.
 *
 * @param {string|null|undefined} title Texto de la vista; sin él se usa solo el título base.
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} — ${BASE}` : BASE;
  }, [title]);
}

export default useDocumentTitle;
